import { UpdateProfileRequest } from '../../application/entities/update-profile-request.entity';
import { UserProfile } from '../../application/entities/user-profile.entity';
import { ProfileOrganizationDto } from '../dto/profile-organization.dto';
import { ProfileUserDto } from '../dto/profile-user.dto';
import { UpdateProfileRequestDto } from '../dto/update-profile-request.dto';

export const toUserProfile = (
  user: ProfileUserDto,
  organization?: ProfileOrganizationDto,
): UserProfile => ({
  uuid: user.uuid,
  email: user.email,
  firstName: user.firstName,
  lastName: user.lastName,
  phone: user.phone,
  avatarUrl: user.avatarUrl,
  role: user.role,
  organizationName: organization?.name ?? '',
});

export const toUpdateProfileRequestDto = (
  request: UpdateProfileRequest,
): UpdateProfileRequestDto => ({
  firstName: request.firstName,
  lastName: request.lastName,
  phone: request.phone,
});
